// crewbit-admin/src/hooks/useStrandedMutations.ts
//
// Mirrors crewbit-mobile/hooks/useStrandedMutations.ts.
// Admin has no offline queue today (filed as §AdminOfflineQueue deferred);
// this hook returns count=0, items=[] always so the banner + sub-screen
// render correctly against an empty queue. When the admin queue substrate
// lands in a future session, this body switches over to read from it.

import { useMemo } from 'react';

export type StrandedReason =
  | 'account_mismatch'
  | 'business_mismatch'
  | 'session_token_changed'
  | 'max_retries_exhausted';

export interface StrandedItem {
  id: string;
  rpcName?: string;
  table?: string;
  operation?: 'insert' | 'update' | 'delete';
  enqueueAuthId: string;
  enqueueBusinessId: string;
  enqueueAt: string;
  strandedAt: string;
  strandedReason: StrandedReason;
  lastError?: string;
  enqueueBusinessName: string | null;
  enqueueAccountEmail: string | null;
}

export interface UseStrandedMutationsReturn {
  count: number;
  items: StrandedItem[];
  retry: (id: string) => Promise<{ success: boolean; reason?: string; error?: string }>;
  discard: (id: string) => Promise<void>;
  isLoading: boolean;
  refresh: () => Promise<void>;
}

export function useStrandedMutations(): UseStrandedMutationsReturn {
  return useMemo(
    () => ({
      count: 0,
      items: [],
      retry: async () => ({ success: false, reason: 'no_admin_queue' }),
      discard: async () => {
        /* no-op */
      },
      isLoading: false,
      refresh: async () => {
        /* no-op */
      },
    }),
    [],
  );
}
